import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

/**
 * searchCustomers
 *
 * Makes a GET request to your existing endpoint:
 *   GET /customer/search/:text/:lastCustomerReturnedId
 *
 * If you rely on a global 'lastCustomerReturnedId', ensure
 * you define it or pass it as an argument to this function.
 */
export const searchCustomers = ({ text, lastCustomerReturnedId = 0 }) => {
  // If you have a global variable, you can use it here,
  // or remove it if you don't actually need it.
  // For example, if you have a global lastCustomerReturnedId,
  // just keep your line as is:
  // return axios.get(`/customer/search/${text}/${lastCustomerReturnedId}`);
  // 
  // If you do not actually track lastCustomerReturnedId, you can
  // omit it or pass a default of 0.

  return axios.get(`/customer/search/${text}/${lastCustomerReturnedId}`);
};

/**
 * useSearchCustomers
 *
 * A small React Query hook that fetches search results
 * for customers based on 'text'.
 */
export const useSearchCustomers = ({
  text,
  lastCustomerReturnedId = 0,
  config,
} = {}) => {
  return useQuery({
    ...config,
    // Include the text in the query key so React Query knows
    // to refetch whenever 'text' changes
    queryKey: ['searchResultsCustomer', text, lastCustomerReturnedId],
    // Only call the API if there's a text string
    queryFn: () =>
      text
        ? searchCustomers({ text, lastCustomerReturnedId })
        : Promise.resolve({ users: [] }),
    enabled: Boolean(text),
  });
};
